import { thousandsFormatter } from "../../../utils";
import { ChartProps } from "../models";
import { ChartVariant, formatShareOfTotal } from "../utils";
import { ChartLegendBase } from "./components";

type ChartLegendEmphasis = "Primary" | "Secondary";

interface ChartLegendProps extends ChartProps {
  colours: string[];
  hasData: boolean;
  defaultValue?: string | null;
  showValues?: boolean;
  emphasis?: ChartLegendEmphasis;
  /** Corner radius (px) for the colour swatch — square for Hub, rounded for Seed. */
  keyBorderRadius?: number;
  /** Index of the segment currently being pointed at, from either the legend or the chart. */
  activeIndex?: number | null;
  /** Reports what the legend is being pointed at, so the chart can highlight it. */
  onActiveIndexChange: (index: number | null) => void;
  /** The chart's resolved brand, which beats the provider. */
  variant?: ChartVariant;
}

export const ChartLegend = ({
  data,
  colours,
  defaultValue = null,
  hasData,
  showValues = true,
  emphasis = "Primary",
  keyBorderRadius = 2,
  activeIndex,
  onActiveIndexChange,
  variant,
}: ChartLegendProps): JSX.Element => {
  const total = Object.values(data).reduce((sum, value) => sum + value, 0);

  return (
    <ChartLegendBase
      labels={Object.keys(data)}
      renderValue={(label) => thousandsFormatter.format(data[label]).toLowerCase()}
      renderPercentage={(label) => formatShareOfTotal(data[label], total)}
      colours={colours}
      hasData={hasData}
      defaultValue={defaultValue}
      showValues={showValues}
      emphasis={emphasis}
      keyBorderRadius={keyBorderRadius}
      activeIndex={activeIndex}
      onActiveIndexChange={onActiveIndexChange}
      variant={variant}
    />
  );
};
